import(/* webpackMode: "eager" */ "/home/runner/work/pos-ui/pos-ui/app/global-error.tsx");
